import { render, staticRenderFns } from "./GardenerOrdersView.vue?vue&type=template&id=0229a578"
import script from "./GardenerOrdersView.vue?vue&type=script&lang=js"
export * from "./GardenerOrdersView.vue?vue&type=script&lang=js"
import style0 from "./GardenerOrdersView.vue?vue&type=style&index=0&id=0229a578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports